import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule } from '@ecm/router';

import { ButtonViewModel } from '../../../../business/model/home/button.view-model';
import { ForbiddenViewModel } from '../../../../business/model/home/forbidden/forbidden.view-model';
import { ParamsUtils } from '../../../../utils/params.utils';

@Component({
    selector: 'terminated-component',
    templateUrl: 'terminated.component.html',
    styleUrls: ['./terminated.component.css'],
    standalone: true,
    imports: [EcmMaterialModule, AsyncPipe, TranslateModule, EcmRouterModule],
})
export class TerminatedComponent {
    @Input()
    public viewModel: ForbiddenViewModel;
    @Input()
    public isDisabledEclair: boolean;

    @Output()
    public readonly clickPrimaryButtonLink = new EventEmitter<ButtonViewModel>();
    @Output()
    public readonly clickSecondaryButtonLink = new EventEmitter<ButtonViewModel>();

    public readonly ParamsUtils = ParamsUtils;

    public doClickPrimaryButtonLink() {
        this.clickPrimaryButtonLink.emit(this.viewModel.primaryButton);
    }
    public doClickSecondaryButtonLink() {
        this.clickSecondaryButtonLink.emit(this.viewModel.secondaryButton);
    }
}
